<svelte:head>

    <link rel='stylesheet' href='/global.css' />

    <script bind:this={mapsLibrary} async
            src="https://maps.googleapis.com/maps/api/js?key=AIzaSyACNGOaMLR7Z7ymn04oqaFFoXg8N-8MFgc&libraries=places&callback=initMap">
    </script>

</svelte:head>

<script>

    import {
        getMember,
        saveMember,
        deleteMember
    } from "../api.svelte";

    import {
        checkUnauthorized
    } from "../../utils/session";

    import {
        generateId,
        USER_STATUS_TEXT
    } from "../../utils/general";

    import {getContext, onMount } from "svelte";

    import { Dropdown } from "carbon-components-svelte";

    const router = getContext('router');

    const LOCATION_TEMPLATE = {
        'name': 'Neue Location',
        'title': 'Neue Location',
        'category': 'general',
        'address': {
            'street': '',
            'zip': '',
            'city': ''
        },
        'coordinates': {
            'lat': 0,
            'lng': 0,
            'placeid': ''
        },
        'phone': '',
        'website': ''
    };

    const MAP_STYLE = [
        {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ];

    export let memberId = false;

    let currentOverlay = 'none';
    let currentLocationId = '';

    let member = false;
    let originalLocation = false;

    let mapsLibrary = null;
    let mapReady = false;
    let mapInitialized = false;
    let mapContainer = null;
    let mapInterval = null;
    let map = false;
    let marker = false;

    let placesTimeout = null;
    let places = false;
    let placesQuery = '';
    let placesResults = false;

    $: getPageTitle = () => {

        return (currentOverlay === 'location')
            ? member['company']['locations'][currentLocationId]['name'] + ' - ' + member['company']['name']
            : member['company']['name'];

    };


    onMount(() => {

        handleGetMember();

    });


    window.initMap = () => {

        mapReady = true;
    };


    let handleGetMember = () => {

        getMember(memberId).then((memberResult) => {

            if (memberResult['status'] !== 'success') {

                checkUnauthorized(router, memberResult);
                console.log(memberResult);
                return;

            }

            member = memberResult['member'];

            console.log(memberResult);

        });

    };

    let handleAddLocation = () => {

        let locationId = generateId(8);

        while (Object.keys(member['company']['locations']).includes(locationId)) {

            locationId = generateId(8);
        }

        member['company']['locations'][locationId] = LOCATION_TEMPLATE;

        console.log(member['company']['locations']);

    };

    let handleSaveMember = () => {

        member['external'] = member['external'] ? 1 : 0;

        saveMember(memberId, member).then((saveResult) => {

            if (saveResult['status'] !== 'success') {

                checkUnauthorized(router, saveResult);
                console.log(saveResult);
                return;

            }

            handleGetMember();

        });

    };

    let handleDeleteMember = () => {

        deleteMember(memberId).then((deleteResult) => {

            if (deleteResult['status'] !== 'success') {

                checkUnauthorized(router, deleteResult);
                console.log(deleteResult);
                return;

            }

            window.close();

        });

    };

    let handleResetMember = () => {

        handleGetMember();
    };

    let handleOpenLocation = (locationId) => {

        currentLocationId = locationId;
        originalLocation = JSON.parse(JSON.stringify(member['company']['locations'][locationId]));
        currentOverlay = 'location';

        if (!mapInitialized && !mapInterval) {

            mapInterval = setInterval(() => setupMap(), 100);
        }

    };

    let handleCloseLocation = () => {

        currentLocationId = '';
        currentOverlay = 'none';

        map = null;
        mapInitialized = false;
        clearInterval(mapInterval);

    };

    let handleResetLocation = () => {

        member['company']['locations'][currentLocationId] = originalLocation;
    };

    let handleDeleteLocation = () => {

        member['company']['locations'][currentLocationId] = null;
        delete member['company']['locations'][currentLocationId];

        handleCloseLocation();

    };

    let setupMap = () => {

        if (!mapContainer) return;

        clearInterval(mapInterval);
        mapInterval = null;

        if (mapInitialized) return;

        mapInitialized = true;

        map = new google.maps.Map(mapContainer, {

            center: new google.maps.LatLng(47.25971215458699, 8.596988690351951),
            zoom: 16,
            styles: MAP_STYLE,
            disableDefaultUI: true

        });

        setLocationMarker();

        places = new google.maps.places.PlacesService(map);

    };

    let setLocationMarker = () => {

        if (marker) {

            marker.setMap(null);
        }

        if (!member['company']['locations'][currentLocationId]['coordinates']['lat']
            || !member['company']['locations'][currentLocationId]['coordinates']['lng']) {

            return;
        }

        const locationPosition = {
            'lat': member['company']['locations'][currentLocationId]['coordinates']['lat'],
            'lng': member['company']['locations'][currentLocationId]['coordinates']['lng']
        };

        marker = new google.maps.Marker({
            position: locationPosition,
            map: map
        });

        map.setCenter(locationPosition);

    };

    let handlePlacesSearch = () => {

        if (placesTimeout) {

            clearTimeout(placesTimeout);
            placesTimeout = null;

        }

        if (placesQuery === '') return;

        placesTimeout = setTimeout(() => {

            let searchRequest = {
                'query': placesQuery
            };

            places.textSearch(searchRequest, placesSearchResults);

        }, 500);

    };

    let placesSearchResults = (results, status) => {

        if (status == google.maps.places.PlacesServiceStatus.OK) {

            placesResults = results;
        }

    };

    let handleChangeGeolocation = () => {

        member['company']['locations'][currentLocationId]['coordinates'] = {
            'lat': '', 'lng': '', 'placeid': ''
        };

    };

    let handlePlaceResult = (place) => {

        member['company']['locations'][currentLocationId]['coordinates'] = {
            'lat': place['geometry']['location'].lat(),
            'lng': place['geometry']['location'].lng(),
            'placeid': place['place_id']
        };

        console.log(member['company']['locations'][currentLocationId]);

        placesResults = false;
        placesQuery = '';

        setLocationMarker();

    };

    $: console.log(member['external'])

</script>


{#if member}

    <div id="member-container">

        <div id="header">

            <h1>{getPageTitle()}</h1>

        </div>

        {#if currentOverlay === 'none'}

            <div id="member-details">

                <div id="company-info" class="details-container">

                    <div class="section-title">Firma</div>

                    <input
                            bind:value={member['company']['name']}
                            name="name"
                            type="text"
                            placeholder="Name der Firma" />

                    <div class="section-title">Kontaktperson</div>

                    <input
                            bind:value={member['company']['contact']}
                            name="contact"
                            type="text"
                            placeholder="Kontaktperson" />

                    <div class="section-title">Strasse / Nr.</div>

                    <input
                            bind:value={member['company']['address']['street']}
                            name="street"
                            type="text"
                            placeholder="Strasse / Nr." />

                    <div class="section-title">PLZ</div>

                    <input
                            bind:value={member['company']['address']['zip']}
                            name="zip"
                            type="text"
                            maxlength="4"
                            placeholder="PLZ" />

                    <div class="section-title">Ort</div>

                    <input
                            bind:value={member['company']['address']['city']}
                            name="city"
                            type="text"
                            placeholder="Ort" />

                    <div class="section-title">Status</div>

                    <Dropdown
                            bind:selectedId={member['status']}
                            class="dropdown-select"
                            items={[
                        {id: 'pending', text: USER_STATUS_TEXT['pending']},
                        {id: 'active', text: USER_STATUS_TEXT['active']},
                        {id: 'inactive', text: USER_STATUS_TEXT['inactive']},
                    ]} />

<!--                    <Dropdown-->
<!--                            bind:selectedId={member['status']}-->
<!--                            class="dropdown-select"-->
<!--                            items={[-->
<!--                        {id: 'pending', text: USER_STATUS_TEXT['pending']},-->
<!--                        {id: 'active', text: USER_STATUS_TEXT['active']},-->
<!--                        {id: 'inactive', text: USER_STATUS_TEXT['inactive']},-->
<!--                        {id: 'blocked', text: USER_STATUS_TEXT['blocked']},-->
<!--                    ]} />-->

                    <label>
                        Kein Mitglied?
                        <input
                                bind:checked={member['external']}
                                type="checkbox" />
                    </label>

                </div>

                <div id="company-meta">

                    <div id="company-locations" class="details-container">

                        <div class="section-title">Locations / Filialen</div>

                        <div id="locations-list">

                            {#each Object.entries(member['company']['locations']) as [locationId, location]}

                                <div on:click={() => handleOpenLocation(locationId)} class="location">

                                    <div class="location-name">{location['name']}</div>

                                </div>

                            {/each}

                        </div>

                        <button
                                on:click={() => handleAddLocation()}
                                class="btn entity-add">

                            Location hinzufügen

                        </button>

                    </div>

                    <div id="company-actions" class="details-container actions-panel">

                        <button on:click={() => handleSaveMember()} class="btn entity-save">Speichern</button>
                        <button on:click={() => currentOverlay = 'delete'} class="btn entity-delete">Löschen</button>
                        <button on:click={() => handleResetMember()} class="btn entity-cancel">Abbrechen</button>

                    </div>

                </div>

            </div>

        {/if}

        {#if currentOverlay === 'delete'}

            <div
                    id="assistant-delete"
                    class="assistant"
                    on:click|self={() => currentOverlay = 'none'}>

                <div class="assistant-container">

                    <button
                            on:click={() => handleDeleteMember()}
                            class="btn entity-delete">

                        <span>Löschen bestätigen</span>

                    </button>

                    <button
                            on:click={() => currentOverlay = 'none'}
                            class="btn entity-cancel">

                        <span>Abbrechen</span>

                    </button>

                </div>

            </div>

        {/if}

        {#if currentOverlay === 'location'}

            <div
                    id="assistant-location"
                    class="assistant">

                <div class="assistant-container details-container">

                    <div class="section-title">Name der Location (nur hier)</div>

                    <input
                            bind:value={member['company']['locations'][currentLocationId]['name']}
                            type="text"
                            placeholder="Name der Location" />

                    <div class="section-title">Name der Location (öffentlich)</div>

                    <input
                            bind:value={member['company']['locations'][currentLocationId]['title']}
                            type="text"
                            placeholder="Öffentlicher Name" />

                    <div class="section-title">Kategorie</div>

                    <Dropdown
                            bind:selectedId={member['company']['locations'][currentLocationId]['category']}
                            class="dropdown-select"
                            items={[
                            { id: 'general', text: 'Standart' },
                            { id: 'coiffeur', text: 'Coiffeur' },
                            { id: 'shop', text: 'Shop' },
                            { id: 'services', text: 'Dienstleistungen' },
                            { id: 'cafe', text: 'Kaffee' },
                            { id: 'craft', text: 'Handwerk' },
                            { id: 'restaurant', text: 'Restaurant' },
                            { id: 'flower', text: 'Blumen'},
                            { id: 'spa', text: 'Wellness & Gesundheit'},
                        ]} />

                    <div class="section-title">Strasse / Nr.</div>

                    <input
                            bind:value={member['company']['locations'][currentLocationId]['address']['street']}
                            type="text"
                            placeholder="Strasse / Nr." />

                    <div class="section-title">Postleitzahl</div>

                    <input
                            bind:value={member['company']['locations'][currentLocationId]['address']['zip']}
                            type="text"
                            maxlength="4"
                            placeholder="PLZ" />

                    <div class="section-title">Ort</div>

                    <input
                            bind:value={member['company']['locations'][currentLocationId]['address']['city']}
                            type="text"
                            placeholder="Ort" />

                    <div class="section-title">Telefon Nr.</div>

                    <input
                            bind:value={member['company']['locations'][currentLocationId]['phone']}
                            type="text"
                            placeholder="Telefon Nr." />

                    <div class="section-title">Website URL</div>

                    <input
                            bind:value={member['company']['locations'][currentLocationId]['website']}
                            type="text"
                            placeholder="URL" />

                </div>

                <div id="location-meta">

                    <div id="locations-geo" class="details-container">

                        <div class="section-title">Geolocation</div>

                        <div id="locations-map" bind:this={mapContainer}></div>

                        {#if member['company']['locations'][currentLocationId]['coordinates']['lat'] &&
                            member['company']['locations'][currentLocationId]['coordinates']['lng']}

                            <button
                                    on:click={() => handleChangeGeolocation()}
                                    id="location-georesult"
                                    class="btn">

                                Neue Geolocation setzen

                            </button>

                        {:else}

                            <div id="location-geosearch">

                                <input
                                        bind:value={placesQuery}
                                        on:input={() => handlePlacesSearch()}
                                        type="text"
                                        placeholder="Location suchen" />

                                {#if placesResults}

                                    <div id="location-results">

                                        {#each placesResults as placeResult}

                                            <div
                                                    on:click={() => handlePlaceResult(placeResult)}
                                                    class="place-result">

                                                <span class="place-name">{placeResult['name']}</span>
                                                <span class="place-address">{placeResult['formatted_address']}</span>

                                            </div>

                                        {/each}

                                    </div>

                                {/if}

                            </div>

                        {/if}

                    </div>

                    <div id="location-actions" class="details-container actions-panel">

                        <button on:click={() => handleCloseLocation()} class="btn entity-back">Zurück</button>
                        <button on:click={() => currentOverlay = 'locationdelete'} class="btn entity-delete">Löschen</button>
                        <button on:click={() => handleResetLocation()} class="btn entity-cancel">Abbrechen</button>

                    </div>

                </div>

            </div>

        {/if}

        {#if currentOverlay === 'locationdelete'}

            <div
                    id="assistant-locationdelete"
                    class="assistant"
                    on:click|self={() => currentOverlay = 'location'}>

                <div class="assistant-container">

                    <button
                            on:click={() => handleDeleteLocation()}
                            class="btn entity-delete">

                        <span>Löschen bestätigen</span>

                    </button>

                    <button
                            on:click={() => currentOverlay = 'location'}
                            class="btn entity-cancel">

                        <span>Abbrechen</span>

                    </button>

                </div>

            </div>

        {/if}

    </div>

{/if}


<style>

    #member-container {
        position: relative;
        display: flex;
        flex-direction: column;
        width: calc(100vw - 40vh);
        padding-top: 4vh;
    }

    #member-details {
        position: relative;
        display: flex;
        flex-direction: row;
        align-self: center;
        align-items: center;
        width: fit-content;
        min-height: 50vh;
        margin-top: 8vh;
        font-family: 'Urbanist', sans-serif;
    }

    .assistant {
        align-self: center;
        margin-top: 8vh;
    }

    .section-title {
        margin-bottom: 1vh;
        font-weight: 500;
        font-size: 1.75vh;
    }

    #company-info {
        margin-right: 6vh;
    }

    #company-meta {
        display: flex;
        flex-direction: column;
    }

    #company-locations {
        margin-bottom: 4vh;
    }

    #locations-list {
        max-height: 30vh;
        overflow-y: scroll;
    }

    .location {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 25vh;
        height: 3vh;
        padding: 1.5vh 2.5vh;
        margin-bottom: 1.5vh;
        border-radius: 1vh;
        cursor: pointer;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.15);
    }

    .location-name {
        font-size: 1.5vh;
    }

    #assistant-location {
        flex-direction: row;
    }

    #assistant-location .assistant-container.details-container {
        align-items: flex-start;
        width: 30vh;
        margin-right: 6vh;
        margin-bottom: 0;
    }

    #locations-geo {
        margin-bottom: 4vh;
    }

    #locations-map {
        width: 30vh;
        height: 12vh;
        margin-bottom: 1vh;
    }

    #location-geosearch {
        position: relative;
    }

    #location-geosearch input {
        margin-bottom: 0;
    }

    #location-results {
        position: absolute;
        display: flex;
        flex-direction: column;
        top: calc(100% + 1vh);
        left: 0;
        width: 27vh;
        max-height: 27vh;
        padding: 1.5vh;
        border-radius: 1vh;
        overflow-y: scroll;
        z-index: 9;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 3px 10px 0px rgba(73, 119, 172, 0.15);
    }

    .place-result {
        display: flex;
        flex-direction: column;
        margin-bottom: 1vh;
        cursor: pointer;
    }

    .place-result:last-child {
        margin-bottom: 0;
    }

    .place-name {
        font-weight: 500;
    }

    label {
        display: flex;
        font-weight: 500;
        font-size: 1.75vh;
    }

    .details-container label input {
        width: unset;
        margin-left: 2vh;
        padding: 0;
    }

</style>
